export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";

export const SET_CURRENT_CHAT_USER = "SET_CURRENT_CHAT_USER";
export const SET_ONLINE_USERS = "SET_ONLINE_USERS";
